module.exports = __webpack_public_path__ + "static/media/floor2.15195633.png";